import React from "react"
import getNewApiAnamnesisApiRiskInfo from "../../utils/newApiAnamnesisRiskInfo"
import { SectionRiskIndicator } from "../../components/SurveyCard/SectionInfo/SectionInfo"
import NewApiSectionAnswers from "./newApiSectionAnswers"

import useTranslate from "../../hooks/useTranslate"
import { formatDate } from "../../utils/datetime"
import { QuestionerAnswersDTOOutput } from "../../sdk"
import classNames from "classnames"

type FAQNewPdfContainerProps = {
  faq: QuestionerAnswersDTOOutput;
  visibleSections: string[];
  gender: string;
  isFirst: boolean
  breakPage: boolean
}
const FAQNewPdfContainer: React.FC<FAQNewPdfContainerProps> = (props: FAQNewPdfContainerProps) => {
  const {faq, visibleSections, gender, isFirst, breakPage} = props
  const translate = useTranslate()

  const renderSectionRiskIndicator = (sectionSlug: string) => {
    const riskInfo = getNewApiAnamnesisApiRiskInfo({anamnesis: faq, sectionSlug, gender})
    if (!riskInfo) return null
    return <SectionRiskIndicator totalPoints={riskInfo.totalPoints} actualPoints={riskInfo.actualPoints}
                                 riskLevel={riskInfo.riskLevel}
                                 showRiskWarning={riskInfo.suicideRisk} forPdf/>
  }

  return (<div className={classNames({'break_inside--avoid_page': breakPage})}>
      {isFirst &&
          <h1 className="header1">{translate('pdf.main')}</h1>}
      <h1
        className="header2 margin-top">{translate('pdf.faq')} {formatDate(faq.updatedAt || 0)}</h1>
      {
        visibleSections.map((sectionSlug) => {
          return <div key={sectionSlug}>
            <div className="anamnesis-title-wrapper">
              <h1 className="header3 vertical-margin">{translate(`questioner.faq.section.${sectionSlug}`)}</h1>
              {
                renderSectionRiskIndicator(sectionSlug)
              }
            </div>
            <NewApiSectionAnswers sectionSlug={sectionSlug} anamnesis={faq} isQuestionAnswerVisible={true}/>
          </div>
        })
      }
    </div>
  )
}
export default FAQNewPdfContainer
